// extracted by mini-css-extract-plugin
export default {"btn__feedback__open__form":"FeedbackForm_btn__feedback__open__form__-Tj6Q","no-scroll":"FeedbackForm_no-scroll__YYd+S"};